import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./VerifyOtp.css";

function VerifyOTP() {
  const { userId } = useParams(); // ✅ Inside component
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");

  const handleVerify = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        `https://devskillz-ifm6.onrender.com/api/student/verify-otp`,
        { userId, otp }
      );

      alert(res.data.message);
      navigate("/login"); // redirect to login after OTP verified
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || "Server error");
    }
  };

  return (
    <div className="otp-page">
      <h2>Verify OTP</h2>
      <form onSubmit={handleVerify}>
        <input
          type="text"
          placeholder="Enter OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          required
        />
        {error && <p className="error">{error}</p>}
        <button type="submit">Verify</button>
      </form>
    </div>
  );
}

export default VerifyOTP;
